import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { observer } from "mobx-react-lite";

import "./GisCoordinates.scss";
import { ViewOrganizationGisCoordinates } from "../../../services/authorization/Permissions";
import {
  ActionsSection,
  ButtonsSection,
  DataSection,
} from "../../../components/data-components/sections/DataSections";
import PageLayout from "../../_layout/PageLayout";
import EditButton from "../../../components/buttons/edit-button/EditButton";
import {
  DisplayCoordinatesSystem,
  DisplayCoordinateSystemDescription,
} from "../gis-coordinates/components/DataComponents";
import { GisCoordinatesStorageModel } from "../../../services/organization/GisCoordinatesStorage";
import { api } from "../../../services/api/ApiService";
import { SettingsMenuItemsModel } from "../SettingsMenuItems";

export default observer(() => {
  const history = useHistory();

  const [settingsMenuItems] = useState(() => SettingsMenuItemsModel.create({}));

  const [gisCoordinateStorage] = useState(() => GisCoordinatesStorageModel.create({}, { api }));

  const menuItems = {
    staticItems: settingsMenuItems.getStaticItems(),
  };

  const handleEditClick = () => {
    history.push("/settings/gis-coordinates/edit");
  };

  return (
    <div className="gis-coordinates">
      <PageLayout
        accessWithOneOfThePermissions={[ViewOrganizationGisCoordinates]}
        titleKey="ViewGisCoordinates.title"
        id="view-gis-coordinates"
        menuItems={menuItems}
        isLoading={gisCoordinateStorage.isLoading}
      >
        <ActionsSection>
          <ButtonsSection>
            <EditButton onClick={handleEditClick} />
          </ButtonsSection>
        </ActionsSection>
        <DataSection labelKey="ViewGisCoordinates.section-title">
          <DisplayCoordinatesSystem coordinateSystem={gisCoordinateStorage.gisCoordinateDetails} />
        </DataSection>
        <DisplayCoordinateSystemDescription
          gisCoordinateDescription={gisCoordinateStorage.gisCoordinateDetails.description}
        />
      </PageLayout>
    </div>
  );
});
